import { render, staticRenderFns } from "./SubjectSelector.vue?vue&type=template&id=fbbe094a"
import script from "./SubjectSelector.ts?vue&type=script&lang=ts&external"
export * from "./SubjectSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./SubjectSelector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports